import { Routes } from '@angular/router';

export const MAIL_LIST_ROUTES: Routes = [
  { path: '', loadComponent: () => import('./components/mail-lists/mail-lists.component').then(m => m.MailListsComponent) }
];
